'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _span;
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import formControlState from "../FormControl/formControlState.js";
import useFormControl from "../FormControl/useFormControl.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import capitalize from "../utils/capitalize.js";
import formHelperTextClasses, { getFormHelperTextUtilityClasses } from "./formHelperTextClasses.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, contained = ownerState.contained, size = ownerState.size, disabled = ownerState.disabled, error = ownerState.error, filled = ownerState.filled, focused = ownerState.focused, required = ownerState.required;
    var slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && "size".concat(capitalize(size)),
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return composeClasses(slots, getFormHelperTextUtilityClasses, classes);
};
var FormHelperTextRoot = styled('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.size && styles["size".concat(capitalize(ownerState.size))],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(memoTheme(function(param) {
    var theme = param.theme;
    var _obj;
    return _object_spread_props(_object_spread({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption), (_obj = {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
    }, _define_property(_obj, "&.".concat(formHelperTextClasses.disabled), {
        color: (theme.vars || theme).palette.text.disabled
    }), _define_property(_obj, "&.".concat(formHelperTextClasses.error), {
        color: (theme.vars || theme).palette.error.main
    }), _define_property(_obj, "variants", [
        {
            props: {
                size: 'small'
            },
            style: {
                marginTop: 4
            }
        },
        {
            props: function(param) {
                var ownerState = param.ownerState;
                return ownerState.contained;
            },
            style: {
                marginLeft: 14,
                marginRight: 14
            }
        }
    ]), _obj));
}));
var FormHelperText = /*#__PURE__*/ React.forwardRef(function FormHelperText(inProps, ref) {
    var props = useDefaultProps({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    var children = props.children, className = props.className, _props_component = props.component, component = _props_component === void 0 ? 'p' : _props_component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = _object_without_properties(props, [
        "children",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = useFormControl();
    var fcs = formControlState({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    var ownerState = _object_spread_props(_object_spread({}, props), {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ _jsx(FormHelperTextRoot, _object_spread_props(_object_spread({
        as: component,
        className: clsx(classes.root, className),
        ref: ref
    }, other), {
        ownerState: ownerState,
        children: children === ' ' ? _span || (_span = /*#__PURE__*/ _jsx("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    }));
});
process.env.NODE_ENV !== "production" ? FormHelperText.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */ children: PropTypes.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: PropTypes.elementType,
    /**
   * If `true`, the helper text should be displayed in a disabled state.
   */ disabled: PropTypes.bool,
    /**
   * If `true`, helper text should be displayed in an error state.
   */ error: PropTypes.bool,
    /**
   * If `true`, the helper text should use filled classes key.
   */ filled: PropTypes.bool,
    /**
   * If `true`, the helper text should use focused classes key.
   */ focused: PropTypes.bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: PropTypes.oneOf([
        'dense'
    ]),
    /**
   * If `true`, the helper text should use required classes key.
   */ required: PropTypes.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.bool
        ])),
        PropTypes.func,
        PropTypes.object
    ]),
    /**
   * The variant to use.
   */ variant: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'filled',
            'outlined',
            'standard'
        ]),
        PropTypes.string
    ])
} : void 0;
export default FormHelperText;
